<form [formGroup]="searchBankFormGroup" style="margin-top: 10px">

    <div class="form-field row">
        <p class="form-field-heading col-sm-12">Bank Name</p>
        <mat-form-field class="col-sm-12">
            <input type="text" matInput formControlName="bankName" placeholder="Please enter bank name" [matAutocomplete]="autoBankName">
            <mat-error>{{ getErrorMessage(searchBankFormGroup.controls.bankName) }}</mat-error>
            <mat-autocomplete #autoBankName="matAutocomplete" (optionSelected)="onBankNameSelected()">
                <mat-option *ngFor="let bankName of filteredBankNames | async"
                            [value]="bankName">
                    {{ bankName }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-sm-12">City</p>
        <mat-form-field class="col-sm-12">
            <input type="text" matInput formControlName="bankCity" (ngModelChange)="getCityName()"
             placeholder="Please enter bank city" [matAutocomplete]="autoBankCity">
            <mat-autocomplete #autoBankCity="matAutocomplete" (optionSelected)="onCitySelected()">
                <mat-option *ngFor="let cityName of filteredCities | async" [value]="cityName">
                    {{ cityName }}
                </mat-option>
            </mat-autocomplete>
            <mat-spinner [diameter]="35" class="mat-spinner" matSuffix *ngIf="loadingCities"></mat-spinner>
            <mat-error>{{ getErrorMessage(searchBankFormGroup.controls.bankCity) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-sm-12">Branch Name</p>
        <mat-form-field class="col-sm-12">
            <input type="text" matInput formControlName="bankBranchName" placeholder="Please enter branch name" [matAutocomplete]="autoBankBranch">
            <mat-autocomplete #autoBankBranch="matAutocomplete" (optionSelected)="onBankBranchSelected()">
                <mat-option *ngFor="let bankBranch of filteredBankBranches | async" [value]="bankBranch">
                    {{ bankBranch }}
                </mat-option>
            </mat-autocomplete>
            <mat-spinner [diameter]="35" class="mat-spinner" matSuffix *ngIf="loadingBranches"></mat-spinner>
            <mat-error>{{ getErrorMessage(searchBankFormGroup.controls.bankBranchName) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-sm-12">Bank’s IFSC</p>
        <mat-form-field class="col-sm-12">
            <input type="text" matInput formControlName="ifscCode">
        </mat-form-field>
    </div>

    <div [hidden]="!showAccountDetailsSection">
        <app-bank-account-details [bankAccount]="bankAccount"></app-bank-account-details>
    </div>
</form>